var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"table-data",class:_vm.tableDataModifyClass},[_c('div',{staticClass:"table-data__cell",class:_vm.cellModifyClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }